import { ElementType } from 'react'
import { observable, runInAction } from 'mobx'
import { nanoid } from 'nanoid'

import { DialogProps } from './types'

type StackedDialog = {
    key: string
    Component: ElementType
    dialogProps: DialogProps
    onClose: (value?: any) => void
}

export const stack = observable<StackedDialog>([])

export const pushToStack = (
    Component: ElementType,
    dialogProps: DialogProps,
    onClose: (value?: any) => void
): string => {
    return runInAction(() => {
        const key = nanoid()
        stack.push({ key, Component, dialogProps, onClose })
        return key
    })
}

export const removeFromStack = (key: string) => {
    runInAction(() => stack.replace(stack.filter((context) => context.key !== key)))
}
